<template>
  <div class="container lms-wrapper-two">
    
    <student-nav />

    <div class="lms-content" @click="closeLevel2()">
      <student-header :navbarmode.sync="navbarMode" ref="lmsv4header" class="filled" />
     
      <div class="lms-content-body" style="height: calc(100vh - 80px)">
        
      
      <vue-custom-scrollbar class="" style="height: calc(100vh - 80px);">
        <div class="container-fluid mg-y-30">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb breadcrumb-style4 mg-b-10">
              <li class="breadcrumb-item"><router-link :to="{ name: 'buddyParticipant' }" class="tx-11" style="color: #444">Шинэ ажилтан</router-link></li>
              <li class="breadcrumb-item active tx-14" aria-current="page">Checklist</li>
            </ol>
          </nav>

          <div class="d-flex mg-t-20">
            <div class="wd-50p">
              <div class="rounded-20 bg-white pd-x-30 pd-y-20">
                <div class="tx-semibold tx-12">Таны BUDDY ажилтан</div>
                <div class="d-flex mg-t-10">
                  <div class="wd-50p pd-r-20 d-flex">
                    <div class="wd-40p">
                      <img :src="`${$store.state.user.userInfo.avator}`" class="wd-100p rounded-20">
                    </div>
                    <div class="wd-60p pd-l-10">
                      <div class="mg-b-20">
                        <div class="text-muted">Нэр:</div>
                        <div class="tx-semibold tx-12">Б.Тэлмэн</div>
                      </div>
                      <div class="mg-b-20">
                        <div class="text-muted">Нэгж:</div>
                        <div class="tx-semibold tx-12">MTG-SHAH</div>
                      </div>
                      <div class="mg-b-20">
                        <div class="text-muted">Албан тушаал:</div>
                        <div class="tx-semibold tx-12">UX дизайнер</div>
                      </div>
                    </div>
                  </div>
                  <div class="wd-50p pd-l-20  bd-l">
                    <div class="mg-b-20">
                      <div class="text-muted">Дотуур утас:</div>
                      <div class="tx-semibold tx-12">97545</div>
                    </div>
                    <div class="mg-b-20">
                      <div class="text-muted">И-мэйл хаяг:</div>
                      <div class="tx-semibold tx-12">telmen_b@golomtbank.com</div>
                    </div>
                    <div class="mg-b-20">
                      <div class="text-muted">Skype</div>
                      <div class="tx-semibold tx-12">Энд дарна уу</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mg-t-30">
                <div v-for="g in 4" class="d-flex mg-b-20 rounded-20 pd-x-30 pd-y-20 bxs">
                  <div class="tx-semibold">Ажлын эхний өдөр</div>
                  <div class="d-flex mg-l-auto">
                    <div>Явц: 50%</div>
                    <div class="rounded-10"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wd-50p pd-l-20">active</div>
          </div>
        </div>
      </vue-custom-scrollbar>
    </div>

    </div>




    
  </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";



import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";

import { localSave, localRead } from "@/libs/util";

const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import { Notification } from "element-ui";

export default {
  components: {
    vueCustomScrollbar,
    
    userCover: () => ({
      component: import("@/views/modules/lms/components/userCover.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentCalendar: () => ({
      component: import("@/views/modules/lms/teacher/components/calendar.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    partUserSidebar: () => ({
      component: import( "@/views/modules/lms/student/parts/userSidebar.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      myResBaseUrl: "https://res.gosmart.mn/",
      welcomes:[
        {id: 1, title: 'IQ шалгалт', img: '', color: '', id: 0, cols: 6, h: 280, bg: 'linear-gradient(135.15deg, #9C14F2 2.15%, #9627DD 65.39%, #B255EC 98.4%)',
          bgimg: 'apps/golomt/bg-exam-1.png'
         },
        {title: 'MQ шалгалт', img: '', color: '', id: 0, cols: 6, h: 280, bg: ' linear-gradient(135.15deg, #FD709A 2.15%, #E43055 65.39%, #F26E7A 98.4%)',
          bgimg: 'apps/golomt/bg-exam-2.png'
         },
        {title: 'EQ шалгалт', img: '', color: '', id: 0, cols: 4, h: 350, bg: ' linear-gradient(135.15deg, #34BDBD 2.15%, #12A0A1 65.39%, #37BABC 98.4%)',
          bgimg: 'apps/golomt/bg-exam-3.png'
         },
        {title: 'TQ шалгалт', img: '', color: '', id: 0, cols: 4, h: 350, bg: ' linear-gradient(135.15deg, #33B7FF 2.15%, #17A0E2 65.39%, #17A0E2 98.4%)' ,
          bgimg: 'apps/golomt/bg-exam-4.png'
        },
        {title: 'Мэргэжлийн шалгалт', img: '', color: '', id: 0, cols: 4, h: 350, bg: 'linear-gradient(135.15deg, #3AC37A 2.15%, #33BF75 65.39%, #55EB9B 98.4%)' ,
          bgimg: 'apps/golomt/bg-exam-5.png'
        },
      ],
      navbarMode: 0,
      mustJoinCourses: {
        all: 0,
        finished: 0,
      }
    };
  },
  // beforeCreate() {
  //   require('@/assets/scss/pages/learning.scss');
  // },
  created() {
    this.fetchResBase();
  },
  mounted() {
  },
  destroyed() {
    // this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    logout(){
      this.$refs.lmsv4header.logout();
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    ...mapActions(["handleAside", "resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    init() {
    },
    
  },
};
</script>
<style>
.bxs{
  color: white;
}
.bxs:nth-child(1){
  background: linear-gradient(135.15deg, #9C14F2 2.15%, #9627DD 65.39%, #B255EC 98.4%);
}
.bxs:nth-child(2){
  background: linear-gradient(135.15deg, #33B7FF 2.15%, #17A0E2 65.39%, #17A0E2 98.4%);
}
.bxs:nth-child(3){
  background: linear-gradient(135.15deg, #FD709A 2.15%, #E43055 65.39%, #F26E7A 98.4%);
}
.bxs:nth-child(4){
  background: linear-gradient(135.15deg, #34BDBD 2.15%, #12A0A1 65.39%, #37BABC 98.4%); 
}
</style>